export class MaterialAliasModel {
    materialAliasId?: string;
    materialId: string;
    materialType: MaterialTypeModel;
    alias: string;
    active?: boolean;
    name: string;
    parent?: string;
    parentId?: string;
    qualifiedName?: string;
    parentAliasName?: string;
    materialTypeId?: number | string;
}

export class MaterialTypeModel {
    materialTypeId?: string;
    name: string;
    materialType: number;
}
